(() => {
  const bbbioInitializeLiquidBiopsyForm = (bbbioRoot) => {
    if (bbbioRoot.dataset.bbbioInitialized === 'true') return;
    const bbbioForm = bbbioRoot.querySelector('[data-bbbio-liquid-biopsy-form]');
    const bbbioSampleList = bbbioRoot.querySelector('[data-bbbio-liquid-biopsy-sample-list]');
    const bbbioSampleTemplate = bbbioRoot.querySelector('[data-bbbio-liquid-biopsy-sample-template]');
    const bbbioStatus = bbbioRoot.querySelector('[data-bbbio-liquid-biopsy-status]');
    const bbbioAddSampleButton = bbbioRoot.querySelector('[data-bbbio-liquid-biopsy-add-sample]');
    const bbbioDownloadButton = bbbioRoot.querySelector('[data-bbbio-liquid-biopsy-download]');
    const bbbioPrintButton = bbbioRoot.querySelector('[data-bbbio-liquid-biopsy-print]');
    if (!bbbioForm || !bbbioSampleList || !bbbioSampleTemplate || !bbbioStatus || !bbbioAddSampleButton || !bbbioDownloadButton || !bbbioPrintButton) return;
    bbbioRoot.dataset.bbbioInitialized = 'true';

    const bbbioToIdPart = (bbbioValue) => bbbioValue
      .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
      .replace(/[^a-zA-Z0-9-]+/g, '-')
      .toLowerCase();

    const bbbioSetStatus = (bbbioMessage, bbbioState) => {
      bbbioStatus.textContent = bbbioMessage;
      bbbioStatus.dataset.bbbioState = bbbioState;
      bbbioStatus.dataset.bbbioVisible = bbbioMessage ? 'true' : 'false';
      bbbioStatus.hidden = !bbbioMessage;
      bbbioStatus.setAttribute('role', bbbioState === 'error' ? 'alert' : 'status');
      bbbioStatus.setAttribute('aria-live', bbbioState === 'error' ? 'assertive' : 'polite');
    };

    const bbbioScrollToStatus = () => {
      const bbbioBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      bbbioStatus.scrollIntoView({ behavior: bbbioBehavior, block: 'center' });
    };

    const bbbioSetPanelState = (bbbioPanel, bbbioVisible) => {
      bbbioPanel.hidden = !bbbioVisible;
      bbbioPanel.querySelectorAll('input, select, textarea').forEach((bbbioField) => {
        bbbioField.disabled = !bbbioVisible;
      });
    };

    const bbbioUpdateSampleWarning = (bbbioCard) => {
      const bbbioMaterial = bbbioCard.querySelector('[data-bbbio-material]').value;
      const bbbioPlasmaSelected = bbbioCard.querySelector('[data-bbbio-service="plasma"]').checked;
      const bbbioExtractionSelected = bbbioCard.querySelector('[data-bbbio-service="extraction"]').checked;
      const bbbioWarning = bbbioCard.querySelector('[data-bbbio-sample-warning]');
      if (bbbioPlasmaSelected && bbbioMaterial !== 'Whole blood for plasma preparation') {
        bbbioWarning.textContent = 'Plasma isolation is normally selected when whole blood is submitted. Confirm the submitted material or requested service.';
        bbbioWarning.hidden = false;
      } else if (bbbioExtractionSelected && bbbioMaterial === 'Extracted cfDNA / ctDNA') {
        bbbioWarning.textContent = 'cfDNA / ctDNA extraction is selected for material already identified as extracted nucleic acid. Confirm the requested workflow.';
        bbbioWarning.hidden = false;
      } else {
        bbbioWarning.textContent = '';
        bbbioWarning.hidden = true;
      }
    };

    const bbbioUpdateMaterialFields = (bbbioCard) => {
      const bbbioMaterial = bbbioCard.querySelector('[data-bbbio-material]').value;
      bbbioSetPanelState(bbbioCard.querySelector('[data-bbbio-panel="blood"]'), bbbioMaterial === 'Whole blood for plasma preparation');
      bbbioSetPanelState(bbbioCard.querySelector('[data-bbbio-panel="plasma"]'), bbbioMaterial === 'Plasma');
      bbbioSetPanelState(bbbioCard.querySelector('[data-bbbio-panel="extracted"]'), bbbioMaterial === 'Extracted cfDNA / ctDNA');
      bbbioUpdateSampleWarning(bbbioCard);
    };

    const bbbioRenumberSamples = () => {
      const bbbioCards = [...bbbioSampleList.querySelectorAll('.bbbio-sample-card')];
      bbbioCards.forEach((bbbioCard, bbbioIndex) => {
        const bbbioNumber = bbbioIndex + 1;
        bbbioCard.dataset.bbbioSampleIndex = String(bbbioNumber);
        bbbioCard.querySelector('[data-bbbio-sample-number]').textContent = String(bbbioNumber);
        bbbioCard.querySelectorAll('[data-bbbio-field]').forEach((bbbioField) => {
          const bbbioKey = bbbioField.dataset.bbbioField;
          const bbbioId = `${bbbioRoot.id}-sample-${bbbioNumber}-${bbbioToIdPart(bbbioKey)}`;
          bbbioField.id = bbbioId;
          bbbioField.name = `sample_${bbbioNumber}_${bbbioKey}`;
          const bbbioLabel = bbbioCard.querySelector(`[data-bbbio-label-for="${bbbioKey}"]`);
          if (bbbioLabel) bbbioLabel.htmlFor = bbbioId;
        });
        bbbioCard.querySelectorAll('[data-bbbio-service]').forEach((bbbioField) => {
          bbbioField.name = `sample_${bbbioNumber}_services`;
        });
        const bbbioWarning = bbbioCard.querySelector('[data-bbbio-sample-warning]');
        bbbioWarning.id = `${bbbioRoot.id}-sample-${bbbioNumber}-warning`;
        bbbioCard.querySelector('[data-bbbio-service-fieldset]').setAttribute('aria-describedby', bbbioWarning.id);
        bbbioCard.querySelectorAll('[data-bbbio-panel]').forEach((bbbioPanel) => {
          const bbbioHeading = bbbioPanel.querySelector('[data-bbbio-panel-heading]');
          bbbioHeading.id = `${bbbioRoot.id}-sample-${bbbioNumber}-${bbbioPanel.dataset.bbbioPanel}-heading`;
          bbbioPanel.setAttribute('aria-labelledby', bbbioHeading.id);
        });
        const bbbioRemoveButton = bbbioCard.querySelector('[data-bbbio-remove-sample]');
        bbbioRemoveButton.disabled = bbbioCards.length === 1;
        bbbioRemoveButton.setAttribute('aria-label', `Remove sample ${bbbioNumber}`);
      });
    };

    const bbbioAttachSampleEvents = (bbbioCard) => {
      bbbioCard.querySelector('[data-bbbio-remove-sample]').addEventListener('click', () => {
        if (bbbioSampleList.querySelectorAll('.bbbio-sample-card').length > 1) {
          bbbioCard.remove();
          bbbioRenumberSamples();
        }
      });
      bbbioCard.querySelector('[data-bbbio-material]').addEventListener('change', () => bbbioUpdateMaterialFields(bbbioCard));
      bbbioCard.querySelectorAll('[data-bbbio-service]').forEach((bbbioCheckbox) => {
        bbbioCheckbox.addEventListener('change', () => bbbioUpdateSampleWarning(bbbioCard));
      });
    };

    const bbbioAddSample = (bbbioShouldFocus) => {
      const bbbioFragment = bbbioSampleTemplate.content.cloneNode(true);
      const bbbioCard = bbbioFragment.querySelector('.bbbio-sample-card');
      bbbioAttachSampleEvents(bbbioCard);
      bbbioSampleList.appendChild(bbbioFragment);
      bbbioUpdateMaterialFields(bbbioCard);
      bbbioRenumberSamples();
      if (bbbioShouldFocus) bbbioCard.querySelector('[data-bbbio-field="sampleId"]').focus();
    };

    const bbbioAddValue = (bbbioTarget, bbbioKey, bbbioValue) => {
      if (Object.prototype.hasOwnProperty.call(bbbioTarget, bbbioKey)) {
        bbbioTarget[bbbioKey] = Array.isArray(bbbioTarget[bbbioKey]) ? bbbioTarget[bbbioKey].concat(bbbioValue) : [bbbioTarget[bbbioKey], bbbioValue];
      } else {
        bbbioTarget[bbbioKey] = bbbioValue;
      }
    };

    const bbbioCollectData = () => {
      const bbbioData = {};
      new FormData(bbbioForm).forEach((bbbioValue, bbbioKey) => {
        if (!bbbioKey.startsWith('sample_')) bbbioAddValue(bbbioData, bbbioKey, bbbioValue);
      });
      bbbioData.samples = [...bbbioSampleList.querySelectorAll('.bbbio-sample-card')].map((bbbioCard) => {
        const bbbioSample = {};
        bbbioCard.querySelectorAll('[data-bbbio-field]').forEach((bbbioField) => {
          if (!bbbioField.disabled && bbbioField.value !== '') bbbioSample[bbbioField.dataset.bbbioField] = bbbioField.value;
        });
        bbbioSample.services = [...bbbioCard.querySelectorAll('[data-bbbio-service]:checked')].map((bbbioField) => bbbioField.value);
        return bbbioSample;
      });
      bbbioData.customerAttestations = {
        accurate: bbbioRoot.querySelector('[data-bbbio-liquid-biopsy-attest="accurate"]').checked,
        noProtectedInformation: bbbioRoot.querySelector('[data-bbbio-liquid-biopsy-attest="identifiers"]').checked,
        hazardsDisclosed: bbbioRoot.querySelector('[data-bbbio-liquid-biopsy-attest="hazards"]').checked
      };
      bbbioData.generatedAt = new Date().toISOString();
      return bbbioData;
    };

    const bbbioValidateRequest = () => {
      bbbioSetStatus('', '');
      if (!bbbioForm.reportValidity()) {
        bbbioSetStatus('Complete all required fields before reviewing the request.', 'error');
        return false;
      }
      if (!bbbioRoot.querySelectorAll('[data-bbbio-liquid-biopsy-project-services] input:checked').length) {
        bbbioSetStatus('Select at least one liquid biopsy service.', 'error');
        bbbioRoot.querySelector('[data-bbbio-liquid-biopsy-project-services] input').focus();
        return false;
      }
      const bbbioSampleWithoutService = [...bbbioSampleList.querySelectorAll('.bbbio-sample-card')]
        .find((bbbioCard) => !bbbioCard.querySelector('[data-bbbio-service]:checked'));
      if (bbbioSampleWithoutService) {
        bbbioSetStatus('Select at least one service for every sample.', 'error');
        bbbioSampleWithoutService.querySelector('[data-bbbio-service]').focus();
        return false;
      }
      return true;
    };

    bbbioAddSampleButton.addEventListener('click', () => bbbioAddSample(true));
    bbbioPrintButton.addEventListener('click', () => window.print());
    bbbioForm.addEventListener('submit', (bbbioEvent) => {
      bbbioEvent.preventDefault();
      if (!bbbioValidateRequest()) { bbbioScrollToStatus(); return; }
      bbbioSetStatus('Required fields are complete. Review the request, then print or save it and submit it according to B&B Bio LLC instructions.', 'success');
      bbbioScrollToStatus();
    });
    bbbioDownloadButton.addEventListener('click', () => {
      if (!bbbioValidateRequest()) { bbbioScrollToStatus(); return; }
      const bbbioBlob = new Blob([JSON.stringify(bbbioCollectData(), null, 2)], { type: 'application/json' });
      const bbbioUrl = URL.createObjectURL(bbbioBlob);
      const bbbioLink = document.createElement('a');
      bbbioLink.href = bbbioUrl;
      bbbioLink.download = 'bnb-bio-liquid-biopsy-ngs-service-request.json';
      document.body.appendChild(bbbioLink);
      bbbioLink.click();
      bbbioLink.remove();
      URL.revokeObjectURL(bbbioUrl);
    });
    bbbioForm.addEventListener('reset', () => window.setTimeout(() => {
      bbbioSampleList.replaceChildren();
      bbbioAddSample(false);
      bbbioSetStatus('', '');
      bbbioRoot.querySelector('[data-bbbio-liquid-biopsy-authorization-date]').valueAsDate = new Date();
    }, 0));

    bbbioRoot.querySelector('[data-bbbio-liquid-biopsy-authorization-date]').valueAsDate = new Date();
    bbbioAddSample(false);
  };

  document.querySelectorAll('[data-bbbio-liquid-biopsy-request-form]').forEach(bbbioInitializeLiquidBiopsyForm);
})();
